import { Component, ElementRef, ViewChild } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { RegistryControllerGetAll$Params } from 'src/app/api/fn/registry/registry-controller-get-all';
import { RegistryItem } from 'src/app/api/models';
import { RegistryService } from 'src/app/api/services';
import { RegistryTypeEnum } from '../enums/registry_type_enum.enum';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-modal-reg-picker',
  templateUrl: './modal-reg-picker.component.html',
  styleUrls: ['./modal-reg-picker.component.scss'],
})
export class ModalRegPickerComponent {
  @ViewChild('keywordFilter') keywordFilter?: ElementRef<HTMLInputElement>;

  protected readonly rowsPerPageOptions = [25, 50, 100, 200, 500];
  question_title: string;
  chosenRegistries?: RegistryItem[] = [];
  selectedRegistryControl = new FormControl<RegistryItem | null>(null);

  registries: RegistryItem[] = [];
  loading: boolean = false;
  totalRecords: number = 0;
  selectedRegistries: RegistryItem[] = [];

  contactTypes?: RegistryTypeEnum[] = [];
  pickerType?: string;
  mainteinanceAgreementId?: number;
  service_id?: number;
  selectedRegistry?: RegistryItem;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService,
    private regService: RegistryService
  ) {
    this.pickerType = config.data.pickerType;
    this.contactTypes = config.data.contactTypes;
    this.question_title = config.data!.question_title;
    this.chosenRegistries = config.data!.chosenRegistries;
    this.mainteinanceAgreementId = config.data?.mainteinanceAgreementId;
    this.service_id = config.data?.service_id;
    this.selectedRegistry = config.data.selectedRegistry;
    this.selectedRegistryControl.setValue(config.data.selectedRegistry);
  }

  loadContacts(event: TableLazyLoadEvent) {
    this.loading = true;
    const params: RegistryControllerGetAll$Params = {
      limit: +event.rows!,
      skip: +event.first!,
      contact_types: this.contactTypes ?? [],
      agreement_id: this.mainteinanceAgreementId,
      // service_id:this.service_id
    };

    if (event.globalFilter != null) {
      // keyword
      if (event.globalFilter[0] != '') {
        params.query = event.globalFilter[0];
      }
      // altro
      if (event.globalFilter[1] != undefined) {
        if (event.globalFilter[1]?.length > 0) {
          params.contact_types = (event.globalFilter[1] as unknown as string[]).map(x => +x);
        }
      }
      // agreement_id (globalFilter[2])
      // if (event.globalFilter[2] != undefined && event.globalFilter[2] !== null) {

      //     const agreementIdFilter = +event.globalFilter[2];

      //     if (!isNaN(agreementIdFilter) && agreementIdFilter > 0) {

      //         params.agreement_id = agreementIdFilter;
      //     } else if (event.globalFilter[2] === '') {

      //         params.agreement_id = undefined;
      //     }
      // }
    }
    this.regService.registryControllerGetAll(params).subscribe({
      next: ({ data }) => {
        this.registries = data.list;
        this.totalRecords = data.count;
        this.loading = false;
      },
    });
    if (this.chosenRegistries) {
      this.selectedRegistries = this.chosenRegistries;
    }
  }

  close() {
    this.ref.close();
  }

  save() {
    // this.ref.close({value: this.selectedRegistries});

    this.pickerType === 'radio'
      ? this.ref.close({ value: this.selectedRegistryControl.value })
      : this.ref.close({ value: this.selectedRegistries });
  }
}
